import React from "react";
import { isEqual } from "lodash";
import { Input, Switch } from "@showitinc/showit-wc";

import VideoServiceURLParser from "../../utils/VideoServiceURLParser";
import AppConstants from "../../constants/AppConstants";
import { initFormatter } from "../../utils/PropertyFormatters";
import {
  ALLOW_FULLSCREEN,
  AUTO_PLAY,
  LOOP,
  SHOW_CONTROLS,
  SHOW_RELATED,
  VIDEO_END,
  VIDEO_ID,
  VIDEO_START,
} from "../../constants/VideoConstants";
import { INPUT_TYPE_NUMBER } from "../../constants/ElementConstants";

const { UPDATE_ACTION_DELETE, UPDATE_ACTION_SET } = AppConstants;

const VideoYoutubeSettings = ({ element, isLocked, onPropChange }) => {
  const _onIDChange = (propInfo) => {
    const info = VideoServiceURLParser.parse(propInfo.value);
    onPropChange({ ...propInfo, value: info ? info.id : propInfo.value });
  };

  const _onSwitch = (propInfo) => {
    const { defaultValue } = propInfo;
    const value = propInfo.value ? 1 : 0;

    onPropChange({
      ...propInfo,
      value,
      action: isEqual(defaultValue, value) ? UPDATE_ACTION_DELETE : UPDATE_ACTION_SET,
    });
  };

  const separatePath = (path) => path.split(".");
  const getValue = (path, fallback) => element.getIn(separatePath(path), fallback);
  const prepChange = (path, defaultValue) => [path, getValue(path), true, false, defaultValue];

  const { onChange: onIdChange } = initFormatter(_onIDChange);
  const { onChange: onSwitch } = initFormatter(_onSwitch);
  const { onChange } = initFormatter(onPropChange);

  return (
    <>
      <Input
        disabled={isLocked}
        label="YouTube ID"
        onSIBeforeChange={onIdChange(...prepChange(VIDEO_ID))}
        onSIInput={onIdChange(...prepChange(VIDEO_ID))}
        reserveContext
        bordered
        placeholder="Enter ID"
        value={getValue(VIDEO_ID, "")}
      />
      <Switch
        checked={getValue(AUTO_PLAY, false)}
        disabled={isLocked}
        label="Autoplay"
        onSIChange={onSwitch(...prepChange(AUTO_PLAY, getValue(AUTO_PLAY, 0)))}
        reserveContext
      />
      <Switch
        checked={getValue(SHOW_CONTROLS, false)}
        disabled={isLocked}
        label="Show Controls"
        onSIChange={onSwitch(...prepChange(SHOW_CONTROLS, getValue(SHOW_CONTROLS, 0)))}
        reserveContext
      />
      <Input
        disabled={isLocked}
        label="Start video at"
        min="0"
        onSIBeforeChange={onChange(...prepChange(VIDEO_START))}
        onSIInput={onChange(VIDEO_START, getValue(VIDEO_START), false)}
        type={INPUT_TYPE_NUMBER}
        units="s"
        value={getValue(VIDEO_START) ?? ""}
      />
      <Input
        disabled={isLocked}
        label="End video at"
        min="0"
        onSIBeforeChange={onChange(...prepChange(VIDEO_END))}
        onSIInput={onChange(VIDEO_END, getValue(VIDEO_END), false)}
        type={INPUT_TYPE_NUMBER}
        units="s"
        value={getValue(VIDEO_END) ?? ""}
      />
      <Switch
        checked={getValue(LOOP, false)}
        disabled={isLocked}
        label="Loop Video"
        onSIChange={onSwitch(...prepChange(LOOP, getValue(LOOP, 0)))}
        reserveContext
      />
      <Switch
        checked={getValue(ALLOW_FULLSCREEN, true)}
        disabled={isLocked}
        label="Show Full Screen Button"
        onSIChange={onSwitch(...prepChange(ALLOW_FULLSCREEN, getValue(ALLOW_FULLSCREEN, 1)))}
        reserveContext
      />
      <Switch
        checked={getValue(SHOW_RELATED, false)}
        disabled={isLocked}
        label="Show Related Videos"
        onSIChange={onSwitch(...prepChange(SHOW_RELATED, getValue(SHOW_RELATED, 0)))}
        reserveContext
      />
    </>
  );
};

export default VideoYoutubeSettings;
